// React
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import { Accordion, Icon, Header, Segment } from 'semantic-ui-react';

// Services
import dateToString from '../../../services/misc/dateToString';

// Types
import { PendingActivities } from '../../../types/Errors';

interface LeadErrorMessageComponentProps {
    pendingActivities: Array<PendingActivities> | undefined;
}

export default function LeadErrorMessageComponent({ pendingActivities = [] }: LeadErrorMessageComponentProps) {
    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState(-1);

    function onAccordionPick(tab: number) {
        setActiveTab(tab === activeTab ? -1 : tab);
    }

    return (
        <>
            {pendingActivities.length ? (
                <Segment basic>
                    <Segment color="orange">
                        <Header as="h3">{t(`lead.detail.errors.headline`)}</Header>
                        <Accordion styled fluid>
                            {pendingActivities.map((item: PendingActivities, ix) => (
                                <React.Fragment key={`err_${ix}`}>
                                    <Accordion.Title
                                        active={activeTab === ix}
                                        style={{ display: 'flex' }}
                                        onClick={() => onAccordionPick(ix)}>
                                        <Icon name="bullhorn" />
                                        &nbsp;
                                        <span style={{ display: 'inline-block' }}>
                                            {item.activityName}
                                            <br />
                                            {t(`lead.detail.errors.retry`)}: {dateToString(item.nextRetry, 'time')}
                                            &nbsp;({dateToString(item.nextRetry, 'dateShort')})
                                        </span>
                                    </Accordion.Title>
                                    <Accordion.Content active={activeTab === ix}>
                                        <div>
                                            <strong>{t(`lead.detail.errors.message`)}:</strong> {item.message}
                                        </div>
                                        <hr />
                                        <div>{item.stackTrace}</div>
                                    </Accordion.Content>
                                </React.Fragment>
                            ))}
                        </Accordion>
                    </Segment>
                </Segment>
            ) : (
                <></>
            )}
        </>
    );
}
